import { render, staticRenderFns } from "./ListingCardWidget.vue?vue&type=template&id=0a5ee1f0&"
import script from "./ListingCardWidget.vue?vue&type=script&lang=js&"
export * from "./ListingCardWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports